export enum AppointmentRequestStatusFilter {
  All = 'All',
  Pending = 'Pending',
  Approved = 'Approved',
  Dismissed = 'Dismissed'
}
